if (!customElements.get('delivery-timeline')) {
  customElements.define(
    'delivery-timeline',
    class DeliveryTimeline extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;

        // Sync immediately in case a variant was already selected before this
        // element was (re)connected to the DOM.
        const initialVariant = this.getCurrentVariant();
        if (initialVariant) this.update(initialVariant);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          this.update(event.data.variant);
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      getCurrentVariant() {
        const json = this.closest('product-info')?.querySelector(
          'variant-selects [data-selected-variant]'
        )?.textContent;
        try {
          return json ? JSON.parse(json) : null;
        } catch (e) {
          return null;
        }
      }

      update(variant) {
        const options = (variant && variant.options) || [];
        let matched = false;

        this.querySelectorAll('[data-size]').forEach((el) => {
          const isMatch = options.includes(el.getAttribute('data-size'));
          el.hidden = !isMatch;
          if (isMatch) matched = true;
        });

        const fallback = this.querySelector('[data-delivery-fallback]');
        if (fallback) fallback.hidden = matched;
      }
    }
  );
}
